<script lang="ts">
  import type { MarkComponentProps } from '@portabletext/svelte';
  import FontDecorator from '../Decorators/FontDecorator.svelte';

  export let portableText: MarkComponentProps<{
    markKey: string;
  }>;
  let font: 'pp-neue-machina' | 'pilat-wide';

  $: font = portableText.markKey === 'fontsPPNeueMachina' ? 'pp-neue-machina' : 'pilat-wide';
</script>

<FontDecorator {font}>
  <slot />
</FontDecorator>
